import { UserExtraLite } from "@frontend/common";

export class Comment {
    constructor(
        public comment: string,
        public id: number,
        public created_at : Date,
        public commenter : UserExtraLite,
        public avatar_disk: string,
        public avatar_path: string,
        public slug: string,
    ) {}
  }